import CliftonPhua from "../Assets/CliftonPhua.png";
import * as React from "react";
import Modal from "@mui/material/Modal";
import { colors } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function Card() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div className="card">
      <div>
        <img
          className="card-img-style"
          src={CliftonPhua}
          alt="judge picture"
        ></img>
      </div>

      <div className="card-text-style">
        <h2 className="card-name-style">Clifton Phua</h2>

        <p className="card-sub-name-style">
          <br /> Director, Labs, BizTech Group, IMDA
        </p>
        <br />

        <button className="readmore-button" onClick={handleOpen}>
          Read More
        </button>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="popup-style">
            <CloseIcon className="close-icon" onClick={handleClose} />

            <h2>Clifton Phua</h2>
            <br />
            <h3>Director, Labs, BizTech Group, IMDA</h3>
            <br />
            <p>
              Dr. Clifton Phua is Director of Labs at Infocomm Media Development
              Authority. His primary focus is to explore and rapidly prototype
              with emerging digital technologies (e.g. AI Computing Hardware,
              Agentic AI, Embodied AI, Robotics, Quantum Computing, AI Safety,
              Content Provenance, etc), to empower Singapore companies and
              workforce.
              <br />
              <br />
              Dr. Clifton has a proven track record of delivering impactful
              solutions and insights for various industries and sectors. He has
              won multiple awards, including The Asset Triple A Digital Awards,
              SAS CEO Award of Excellence, and First Place in Kaggle's GE Flight
              Quest Competition. He was Chief Technology Officer of Digital
              Systems at ST Engineering, and also led the customer facing data
              scientist team in APAC at DataRobot, and the data scientist team
              at NCS.
              <br />
              <br />
              Dr. Clifton holds a PhD and a Bachelor's degree (First Class
              Honours) in Information Technology from Monash University in
              Australia. He also completed the INSEAD Advanced Management
              Program.
            </p>
          </div>
        </Modal>
      </div>

      <div></div>
    </div>
  );
}

export default Card;
